import { useEffect } from 'react';

import { type TModePath, useSpotlightAPI } from '@frontend/components/Spotlight/store';

type TModeDataUpdate =
  | Record<TModePath, unknown>
  | ((prev: Record<TModePath, unknown>) => Record<TModePath, unknown>);

/**
 * Register mode data for the calling component's lifetime, reverting it on unmount.
 * Pass a `Record<path, data>` (each path registered once — a conflict throws in dev
 * / warns in prod) or a function that receives the whole current map and returns
 * the new one (the escape hatch for modifying already-registered data). Pass a
 * stable (memoized or module-constant) reference — a new identity re-applies.
 */
export function useSpotlightModeData(update: TModeDataUpdate): void {
  const api = useSpotlightAPI();
  useEffect(
    () =>
      typeof update === 'function' ? api.updateModeData(update) : api.registerModeData(update),
    [api, update]
  );
}
